import { dispatcher } from 'dispatcher';
import { useLocation } from 'react-router-dom';
import { useCallback, useEffect, useState } from 'react';
import { prop, path } from 'ramda';

import { getFriendlyUrl } from 'js/utils/url.util';
import { useFindItemMenu } from 'js/app/hooks/menu/useMenu';
import { useAppSelector, useUserSelector } from 'js/store/hooks';
import { MENU_CLASSES } from '@interlayer/js/app/components/main/DefaultMenu/constants';

export const useIsShowChat = () => {
    const [isShow, setIsShow] = useState(false);

    const location = useLocation();
    const findItemMenu = useFindItemMenu();
    const isLoggedIn = useUserSelector(prop('isLoggedIn'));
    const enabled = useAppSelector(path(['chatWidget', 'enabled']));

    const updateIsShow = useCallback(() => {
        const isAdminAvailable = window.Communication?.API?.chat?.getAdminStatus()?.isAdminAvailable;
        const isGuestChatPage = findItemMenu(getFriendlyUrl(location?.pathname))
            ?.cssClasses?.includes(MENU_CLASSES.SHOW_CHAT_GUEST);

        setIsShow(enabled && isAdminAvailable && (isGuestChatPage || isLoggedIn));
    }, [enabled, findItemMenu, isLoggedIn, location?.pathname]);

    useEffect(() => {
        dispatcher.listen('chat:AdminStatusChange', updateIsShow);

        return () => {
            dispatcher.removeListener('chat:AdminStatusChange', updateIsShow);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        updateIsShow();
    }, [updateIsShow]);

    return isShow;
};
